module.exports = __webpack_public_path__ + "img/vanHouten.d4285d23.png";